import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setRowInit_({ commit }) {
		commit(types.ROW_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setDetailList_({ commit }, { status, changeArr }) {
		commit(types.DETAIL_LIST, { status, changeArr });
	},
	/**call API */
	async getCommCodes_({ commit, rootState }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getAllCommCodes_({ state, commit, rootState }, { key, codeType }) {
		try {
			const targetArray = state[key];
			const { header, body } = await api.getCommCodes(codeType, rootState['commonStore'].user.plantCd);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: [...targetArray, ...list] });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			throw error?.header || error;
		}
	},
	async getList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data?.header?.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getDetailList_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getDetailList({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data?.header?.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'detailList', value: resultList });
			} else if (data.header.code === 3) {
			}
			return data?.header;
		} catch (error) {
			throw error.header || error;
		}
	},
	async getSgrpList_({ state, dispatch }) {
		const { lgrpCd } = state.selectedRow;
		const key = 'sgrpList';
		await dispatch('getCommCodes_', { key, codeType: lgrpCd });
	},
	async getAllSgrpList_({ state, dispatch, commit }) {
		const { lgrpList } = state;
		const key = 'sgrpAllList';
		commit(types.DEFAULT_ASSIGN, { key, value: [] });
		for (const lgrp of lgrpList) {
			await dispatch('getAllCommCodes_', { key, codeType: lgrp.value });
		}
	},
	async saveData_({ state }) {
		try {
			const response = await api.saveData(
				{ custCd: state.searchParams.custCd, cpnyScn: state.searchParams.cpnyScn },
				{ detailList: state.detailList }
			);
			return response;
		} catch (error) {
			throw error?.header || error;
		}
	}
};
